var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import ja from 'date-fns/locale/ja';
import { useCallback, useState } from 'react';
import DatePicker, { registerLocale, } from 'react-datepicker';
import { useField } from 'react-final-form';
import { FieldErrorText } from '@/components/functional/Form/FieldErrorText/FieldErrorText';
import { datePickerMultiFieldStyle } from '@/components/ui/Form/DatePickerMultiField/style';
registerLocale('ja', ja);
/**
 * 日付入力 Field
 */
export const DatePickerMultiField = (props) => {
    const { className, dateFormat = 'yyyy年MM月dd日', fieldNameOfEndDate, fieldNameOfStartDate, isError: propIsError, popperPlacement = 'bottom-start' } = props, datePickerProps = __rest(props
    // 開始日の field
    , ["className", "dateFormat", "fieldNameOfEndDate", "fieldNameOfStartDate", "isError", "popperPlacement"]);
    // 開始日の field
    const { input: { onBlur: onBlurStart, onChange: onChangeStart, value: startValue }, meta: { invalid: invalidStart, touched: touchedStart }, } = useField(fieldNameOfStartDate);
    // 終了日の field
    const { input: { onBlur: onBlurEnd, onChange: onChangeEnd, value: endValue }, meta: { invalid: invalidEnd, touched: touchedEnd }, } = useField(fieldNameOfEndDate);
    /**
     * エラーかどうか
     */
    const isError = propIsError || (invalidEnd && touchedEnd) || (invalidStart && touchedStart);
    /**
     * フォーカスが外れた時の処理
     */
    const onBlur = useCallback(() => {
        onBlurStart();
        onBlurEnd();
    }, [onBlurStart, onBlurEnd]);
    const [dateRange, setDateRange] = useState([
        startValue || null,
        endValue || null,
    ]);
    const [startDate, endDate] = dateRange;
    /**
     * 日付変更時の処理
     */
    const onChange = useCallback((newDate) => {
        const [newStartDate, newEndDate] = newDate;
        setDateRange(newDate);
        onChangeStart(newStartDate);
        onChangeEnd(newEndDate);
    }, [onChangeStart, onChangeEnd]);
    const style = datePickerMultiFieldStyle();
    return (_jsxs(_Fragment, { children: [_jsx(DatePicker, Object.assign({}, datePickerProps, { ariaInvalid: isError ? 'true' : undefined, autoComplete: 'off', className: style.base({ class: className }), dateFormat: dateFormat, endDate: endDate || undefined, locale: 'ja', name: 'date', onBlur: onBlur, onChange: onChange, popperPlacement: popperPlacement, selected: startDate, selectsRange: true, showTimeSelect: false, startDate: startDate || undefined, swapRange: true })), _jsx(FieldErrorText, { name: fieldNameOfStartDate }), _jsx(FieldErrorText, { name: fieldNameOfEndDate })] }));
};
